import { render, staticRenderFns } from "./ModalEditarMidiaColaboracao.vue?vue&type=template&id=2e551523&scoped=true"
import script from "./ModalEditarMidiaColaboracao.vue?vue&type=script&lang=js"
export * from "./ModalEditarMidiaColaboracao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarMidiaColaboracao.vue?vue&type=style&index=0&id=2e551523&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e551523",
  null
  
)

export default component.exports